var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAud = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7338_14885)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 12.2673C24 18.8947 18.6274 24.2673 12 24.2673C5.37262 24.2673 0 18.8947 0 12.2673C0 12.2701 12 0.268693 12 0.267334C18.6274 0.267334 24 5.63996 24 12.2673Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9688 12.2681H12.0009C12.0009 12.2572 12.0009 12.2468 12.0009 12.236C11.9902 12.2467 11.9795 12.2574 11.9688 12.2681Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 6.52807C12 4.41659 12 3.03298 12 0.267212H11.998C5.3715 0.26829 0 5.6404 0 12.2672H6.26086V8.7416L9.78642 12.2672H11.9679C11.9787 12.2565 11.9894 12.2458 12 12.2351C12 11.4266 12 10.7052 12 10.0537L8.47443 6.52807H12Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.07027 1.83374C4.19344 2.90244 2.63316 4.46272 1.56445 6.33955V12.2685H4.69491V4.96424V4.96419H11.9993C11.9993 3.97687 11.9993 3.03627 11.9993 1.83374H6.07027Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0008 10.7925L7.73739 6.52907H6.26172C6.26172 6.52903 6.26172 6.52907 6.26172 6.52907L12.0008 12.2681H12.0008C12.0008 12.2681 12.0008 11.2507 12.0008 10.7925Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.23827 14.3533L7.89686 15.7304L9.38406 15.3866L8.71806 16.7602L9.91403 17.7086L8.42495 18.0442L8.42913 19.5706L7.23827 18.6157L6.04745 19.5706L6.05163 18.0442L4.5625 17.7086L5.75852 16.7602L5.09242 15.3866L6.57972 15.7304L7.23827 14.3533Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9687 16.9626L18.298 17.6512L19.0416 17.4793L18.7086 18.1661L19.3066 18.6403L18.5621 18.8081L18.5641 19.5713L17.9687 19.0938L17.3733 19.5713L17.3754 18.8081L16.6309 18.6403L17.2288 18.1661L16.8958 17.4793L17.6394 17.6512L17.9687 16.9626Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9043 9.65796L15.2336 10.3466L15.9772 10.1746L15.6442 10.8614L16.2422 11.3356L15.4977 11.5034L15.4997 12.2666L14.9043 11.7891L14.3089 12.2666L14.3109 11.5034L13.5664 11.3356L14.1644 10.8614L13.8314 10.1746L14.575 10.3466L14.9043 9.65796Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9687 5.48608L18.298 6.17468L19.0416 6.00279L18.7086 6.68955L19.3066 7.16374L18.5621 7.3316L18.5641 8.09482L17.9687 7.6173L17.3733 8.09482L17.3754 7.3316L16.6309 7.16374L17.2288 6.68955L16.8958 6.00279L17.6394 6.17468L17.9687 5.48608Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6426 8.61499L20.9718 9.30358L21.7155 9.13165L21.3825 9.81841L21.9804 10.2926L21.2359 10.4605L21.2379 11.2237L20.6426 10.7462L20.0472 11.2237L20.0492 10.4605L19.3047 10.2926L19.9027 9.81841L19.5697 9.13165L20.3132 9.30358L20.6426 8.61499Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.73 12.2673L18.989 13.0645H19.8272L19.1491 13.5572L19.4082 14.3543L18.73 13.8616L18.0519 14.3543L18.3109 13.5572L17.6328 13.0645H18.471L18.73 12.2673Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7338_14885"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.267334)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAud);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/AUD.6643fbba5b86b2ecb215d21458011034.svg";